import React, { useState, useRef, useEffect, useCallback } from "react";
import "./PerfectOnlineTutors.css";

const tutorsData = [
  {
    image: "./teacher_img1.png",
    name: "Sneha Kulkarni",
    expertise: "(Class 1 - 8 Teacher)",
    stars: 5,
    ratingText: "92% Positive Ratings",
    description:
      "10 years of teaching experience for Class 1 to 8, specializing in Maths, Science, & Social Studies. I teach Indian & international boards across the USA, UK, and Europe, focusing on building a solid academic foundation.",
    verified: true,
  },
  {
    image: "./teacher_img2.png",
    name: "Ishani.K",
    expertise: "(Hindi Language Classes)",
    stars: 5,
    ratingText: "90% Positive Ratings",
    description:
      "I have over 20 years of teaching experience in Sanskrit and 15 years in Hindi. I have taught more than 150 foreigners, NRIs, and non-Hindi speaking professionals according to their needs and requirements.",
    verified: true,
  },
  {
    image: "./teacher_img3.png",
    name: "Tanirika Sen",
    expertise: "(English Trainer)",
    stars: 5,
    ratingText: "89% Positive Ratings",
    description:
      "I have strong communication skills and over 15 years of experience teaching English and communication in schools and institutes. I hold an MBA in HR, a Master’s in English, and a Bachelor’s degree in English Honours.",
    verified: true,
  },
  {
    image: "./teacher_jai.png",
    name: "Jaidev V",
    expertise: "(Entrance Exam Coaching)",
    stars: 4.5,
    ratingText: "89% Positive Ratings",
    description:
      "I teach subjects for IIT-JEE Mains & Advanced and Boards. I am a teacher with over 8+ years of experience in the field, focused on strategy, practice, and achieving better results.",
    verified: true,
  },
  {
    image: "./teacher_img4.png",
    name: "Prisha B",
    expertise: "(Mathematics Classes)",
    stars: 5,
    ratingText: "92% Positive Ratings",
    description:
      "I am a Mathematics teacher who enjoys helping students understand concepts clearly. I take online classes and focus on simple explanations, regular practice, and student-friendly methods to make learning maths easy and enjoyable.",
    verified: true,
  },
  {
    image: "./teacher_img5.png",
    name: "Darshita T",
    expertise: "(Vocal Music Classes)",
    stars: 4,
    ratingText: "80% Positive Ratings",
    description:
      "Trained Indian Classical Vocalist with 30 years of experience. Performed at top levels including The Music Academy. Passionate about helping students develop strong vocals and confidence.",
    verified: true,
  },
  {
    image: "./teacher_img6.png",
    name: "Virendra M",
    expertise: "(I-V Classes)",
    stars: 5,
    ratingText: "90% Positive Ratings",
    description:
      "I am an experienced tutor with 8+ years of teaching Mathematics, Science, and English up to Class 12 across various Indian and international boards. I help students build strong concepts and confidence in their studies.",
    verified: true,
  },
  {
    image: "./teacher_img7.png",
    name: "Suresh Matt",
    expertise: "(Physics Tutor)",
    stars: 5,
    ratingText: "92% Positive Ratings",
    description:
      "I have completed MPhil in Physics and am an experienced Physics tutor focused on concept clarity and problem-solving, helping students understand fundamentals and excel in exams.",
    verified: true,
  },
];

const CLONE_COUNT = 3;
const extendedTutorsData = [
  ...tutorsData.slice(-CLONE_COUNT),
  ...tutorsData,
  ...tutorsData.slice(0, CLONE_COUNT),
];

const PerfectOnlineTutors = () => {
  const scrollRef = useRef(null);
  const isJumpingRef = useRef(false);

  const handleInfiniteJump = useCallback(() => {
    if (!scrollRef.current || isJumpingRef.current) return;
    const container = scrollRef.current;
    const { scrollLeft, scrollWidth, clientWidth } = container;

    const firstCard = container.querySelector(".perfect-tutor-card");
    if (!firstCard) return;
    const gap = Number.parseFloat(window.getComputedStyle(container).gap || "20");
    const isMobile = window.innerWidth <= 768;
    const stepWidth = isMobile ? container.clientWidth + gap : firstCard.offsetWidth + gap;

    const cards = Array.from(container.querySelectorAll(".perfect-tutor-card"));
    const realDataStartCard = cards[CLONE_COUNT];
    const realDataEndCard = cards[CLONE_COUNT + tutorsData.length];
    
    if (!realDataStartCard || !realDataEndCard) return;

    // Use stepWidth for the jump distance calculation
    const jumpDistance = tutorsData.length * stepWidth;

    // Thresholds for jumping
    if (scrollLeft <= realDataStartCard.offsetLeft - (container.clientWidth / 2)) {
      isJumpingRef.current = true;
      container.scrollLeft = scrollLeft + jumpDistance;
      setTimeout(() => (isJumpingRef.current = false), 50);
    } else if (scrollLeft + container.clientWidth >= realDataEndCard.offsetLeft + (container.clientWidth / 2)) {
      isJumpingRef.current = true;
      container.scrollLeft = scrollLeft - jumpDistance;
      setTimeout(() => (isJumpingRef.current = false), 50);
    }
  }, []);

  const checkScroll = () => {
    if (scrollRef.current) {
      handleInfiniteJump();
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const cards = Array.from(container.querySelectorAll(".perfect-tutor-card"));
      if (cards.length > CLONE_COUNT) {
        const targetCard = cards[CLONE_COUNT];
        if (targetCard) {
          const targetScrollLeft = targetCard.offsetLeft - (container.clientWidth - targetCard.offsetWidth) / 2;
          container.scrollLeft = targetScrollLeft;
        }
      }
    }
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  const scroll = direction => {
    if (!scrollRef.current || isJumpingRef.current) return;
    const container = scrollRef.current;
    if (!container) return;
    const cards = Array.from(container.querySelectorAll(".perfect-tutor-card"));
    if (cards.length === 0) return;

    const containerCenter = container.scrollLeft + container.clientWidth / 2;

    // Find the card currently most in view (closest to center)
    let closestIndex = 0;
    let minDistance = Infinity;

    cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(cardCenter - containerCenter);
      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    let targetIndex = direction === "left" ? closestIndex - 1 : closestIndex + 1;

    // Boundary check (we have clones, but let's be safe)
    if (targetIndex < 0) targetIndex = 0;
    if (targetIndex >= cards.length) targetIndex = cards.length - 1;

    const targetCard = cards[targetIndex];
    if (targetCard) {
      // Calculate scroll position to center this card
      // targetScrollLeft = targetCard.offsetLeft - (containerWidth - cardWidth) / 2
      const targetScrollLeft = targetCard.offsetLeft - (container.clientWidth - targetCard.offsetWidth) / 2;

      container.scrollTo({
        left: targetScrollLeft,
        behavior: "smooth",
      });
    }

    setTimeout(checkScroll, 500);
  };

  const renderStars = count => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      // Just rendering simple star icons. The old layout used './Star.png'.
      stars.push(
        <div className="star-icon-wrapper" key={i}>
          <img src="./Star.png" alt="star" className="star-icon" />
        </div>,
      );
    }
    return stars;
  };

  return (
    <div className="perfect-tutor-container">
      <div className="perfect-tutor-header-wrapper">
        <h2 className="perfect-tutor-main-heading">
          Discover Your <span className="highlight-text">Perfect Online Tutor</span>
        </h2>
        <p className="perfect-tutor-sub-heading">
          Let's have a look to our expert and experienced home tutors and online tutors.
        </p>
      </div>

      <div className="perfect-tutor-slider-wrapper">
        <div
          className="arrow-side-left"
          onClick={() => scroll("left")}
          aria-label="Previous cards">
          <img src="/arrow_capa.png" alt="Previous" className="slider-arrow-img slider-arrow-img-left" />
        </div>

        <div className="perfect-tutor-list" ref={scrollRef} onScroll={checkScroll}>
          {extendedTutorsData.map((tutor, index) => (
            <div className="perfect-tutor-card" key={`${tutor.name}-${index}`}>
              <div className="card-header-area">
                <img
                  src={tutor.image}
                  alt={tutor.name}
                  className="tutor-profile-img"
                  onError={e => {
                    e.target.src = "https://via.placeholder.com/88";
                  }} // Fallback if local image missing
                />

                <div className="card-title-area">
                  <div className="verified-badge">
                    <img
                      src="./Frame.png"
                      alt="Verified Badge"
                      className="verified-icon"
                      onError={e => {
                        e.target.style.display = "none";
                      }}
                    />
                    <span className="verified-text">Verified Tutor</span>
                  </div>
                  <h3 className="tutor-name">{tutor.name}</h3>
                  <h4 className="tutor-expertise">{tutor.expertise}</h4>

                  <div className="stars-and-rating">
                    <div className="stars-container">{renderStars(tutor.stars)}</div>
                    <span className="rating-text">({tutor.ratingText})</span>
                  </div>
                </div>
              </div>

              <div className="card-desc-area">
                <div className="desc-label">Description</div>
                <p className="desc-text">{tutor.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div
          className="arrow-side-right"
          onClick={() => scroll("right")}
          aria-label="Next cards">
          <img src="/arrow_capa_right.png" alt="Next" className="slider-arrow-img slider-arrow-img-right" />
        </div>
      </div>
    </div>
  );
};

export default PerfectOnlineTutors;
